import type { Section } from "./SortableRow";

/** Build root-number and parent-id maps for label generation in one pass. */
export function buildLabelData(sections: Section[]) {
  const rootNumbers = new Map<string, number>();
  const childCounters = new Map<string, number>();
  let rootCount = 0;
  for (const s of sections) {
    if (s.parent_id === null) {
      rootCount++;
      rootNumbers.set(s.id, rootCount);
    }
  }
  const parentIds = new Set(sections.filter((s) => s.parent_id !== null).map((s) => s.parent_id));
  return { rootNumbers, childCounters, parentIds };
}

/** Build a map of sectionId → numeric label string ("1", "2.1", etc.) for all sections. */
export function buildSectionLabels(sections: Section[]): Map<string, string> {
  const rootNumbers = new Map<string, number>();
  const childCounters = new Map<string, number>();
  const labels = new Map<string, string>();
  let rootCount = 0;
  for (const s of sections) {
    if (s.parent_id === null) {
      rootCount++;
      rootNumbers.set(s.id, rootCount);
      labels.set(s.id, `${rootCount}`);
    } else {
      const parentNum = rootNumbers.get(s.parent_id) ?? 0;
      const childNum = (childCounters.get(s.parent_id) ?? 0) + 1;
      childCounters.set(s.parent_id, childNum);
      labels.set(s.id, `${parentNum}.${childNum}`);
    }
  }
  return labels;
}

/**
 * Section names as the audit dialog's Item column shows them — "2.1 Clinical Efficacy"
 * rather than a bare prompt-library id.
 */
export function buildSectionEntityNames(sections: Section[]): Map<string, string> {
  const labels = buildSectionLabels(sections);
  const names = new Map<string, string>();
  for (const section of sections) {
    const label = labels.get(section.id);
    names.set(section.id, label ? `${label} ${section.name}` : section.name);
  }
  return names;
}
